import {
  ClassAttributes,
  HTMLAttributes,
  TableHTMLAttributes,
  TdHTMLAttributes,
  ThHTMLAttributes
} from 'react'

type TableProps = ClassAttributes<HTMLTableElement> & TableHTMLAttributes<HTMLTableElement>
type TrProps = ClassAttributes<HTMLTableRowElement> & HTMLAttributes<HTMLTableRowElement>
type ThProps = ClassAttributes<HTMLTableCellElement> & ThHTMLAttributes<HTMLTableCellElement>
type TdProps = ClassAttributes<HTMLTableCellElement> & TdHTMLAttributes<HTMLTableCellElement>

export function table({ children, ...props }: TableProps) {
  return (
    <table
      className='my-5 w-full max-w-full table-fixed border-collapse border border-gray-200 dark:border-gray-700 dark:text-white'
      {...props}
    >
      {children}
    </table>
  )
}

export function tr({ children, ...props }: TrProps) {
  return (
    <tr className='border border-gray-200 dark:border-gray-700' {...props}>
      {children}
    </tr>
  )
}

export function th({ children, ...props }: ThProps) {
  return (
    <th
      className='break-words border border-gray-200 dark:border-gray-700 p-2 text-center bg-gray-100 dark:bg-medium5'
      {...props}
    >
      {children}
    </th>
  )
}

export function td({ children, ...props }: TdProps) {
  return (
    <td
      className='break-words border border-gray-200 dark:border-medium3 p-2 break-all bg-white dark:bg-medium7'
      {...props}
    >
      {children}
    </td>
  )
}
